module.exports = __webpack_public_path__ + "static/media/point.241ad27f.svg";